import React from 'react';
import { CategoryKeywordSearchModel } from '../../Models/CategoryKeywordSearchModel';
import { ClientModel, clientModelInitial } from '../../Models/ClientModel';
import { KeywordModel, keywordModelInitial } from '../../Models/KeywordModel';
import { SearchStatus } from '../../shared/enum/SearchStatus';

export interface IKeywordInclusionContext {
    selectedClient: ClientModel,
    setSelectedClient: (client: ClientModel) => void,
    clientList: ClientModel[],
    setClientList: (clients: ClientModel[]) => void,
    selectedInitialDate: Date | null,
    setSelectedInitialDate: (date: Date | null) => void,
    selectedFinalDate: Date | null,
    setSelectedFinalDate: (date: Date | null) => void,
    selectedKeyword: KeywordModel,
    setSelectedKeyword: (keyword: KeywordModel) => void,
    keywordList: KeywordModel[],
    setKeywordList: (keywords: KeywordModel[]) => void,
    clientError: boolean,
    setClientError: (error: boolean) => void,
    initialDateError: boolean,
    setInitialDateError: (error: boolean) => void,
    finalDateError: boolean, 
    setFinalDateError: (error: boolean) => void,
    searchStatus: SearchStatus,
    setSearchStatus: (status: SearchStatus) => void,
    categoryKeywordSearchResult: CategoryKeywordSearchModel[],
    setCategoryKeywordSearchResult: (categories: CategoryKeywordSearchModel[]) => void,
    openAddNewKeywordDialog: boolean,
    setOpenAddNewKeywordDialog: (open: boolean) => void
}

export const keywordInclusionContextInitial: IKeywordInclusionContext = {
    selectedClient: clientModelInitial,
    setSelectedClient: () => { ''; },
    clientList: [],
    setClientList: () => { ''; },
    selectedInitialDate: null,
    setSelectedInitialDate: () => { ''; },
    selectedFinalDate: null,
    setSelectedFinalDate: () => { ''; },
    selectedKeyword: keywordModelInitial,
    setSelectedKeyword: () => { ''; },
    keywordList: [],
    setKeywordList: () => { ''; },
    clientError: false,
    setClientError: () => { ''; },
    initialDateError: false,
    setInitialDateError: () => { ''; },
    finalDateError: false,
    setFinalDateError: () => { ''; },
    searchStatus: SearchStatus.INITIAL,
    setSearchStatus: () => { ''; },
    categoryKeywordSearchResult: [],
    setCategoryKeywordSearchResult: () => { ''; },
    openAddNewKeywordDialog: false,
    setOpenAddNewKeywordDialog: () => { ''; }
};

export const KeywordInclusionContext = React.createContext(keywordInclusionContextInitial);



